import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'bau365-product-section-key-facts',
  templateUrl: './section-key-facts.component.html',
  styleUrls: ['./section-key-facts.component.scss'],
})
export class SectionProductKeyFactsComponent implements OnChanges {
  @Input() key_facts?: string[];

  keyFacts: string[] | undefined = [];
  shownKeyFacts: string[] | undefined = [];
  keyFactsExpanded = false;
  keyFactsOverflowing = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['key_facts']) {
      this.prepareKeyFacts(this.key_facts);
    }
  }

  trackByKeyFacts = (index: number, item: string) => item;

  prepareKeyFacts(key_facts?: string[]) {
    if (key_facts) {
      this.keyFacts = key_facts;
      this.shownKeyFacts = key_facts?.slice(0, 5);

      if (this.keyFacts && this.keyFacts.length > 5) {
        this.keyFactsOverflowing = true;
      }
    }
  }

  showAllKeyFacts() {
    this.shownKeyFacts = this.keyFacts;
    this.keyFactsExpanded = true;
  }

  showDefaultKeyFacts() {
    this.shownKeyFacts = this.keyFacts?.slice(0, 5);
    this.keyFactsExpanded = false;
  }
}
